// jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// AOS (Animate on Scroll)
import AOS from 'aos';
import 'aos/dist/aos.css';

// Match Height
import 'jquery-match-height/jquery.matchHeight';

// FontAwesome (enable only if you're using it)
// import '@fortawesome/fontawesome-free/js/fontawesome.min';
// import '@fortawesome/fontawesome-free/js/solid.min';
// import '@fortawesome/fontawesome-free/js/regular.min';
// import '@fortawesome/fontawesome-free/js/brands.min';

// Custom animations (enable if you’ve got this file)
import {initCardsSlider, initMarqueeSlider, initTestimonialSlider, initIconSlider, initMobileSwiper} from './sliders';

// AOS init on window load
window.addEventListener('load', () => {

    initMarqueeSlider();
    initTestimonialSlider();
    initCardsSlider();
    initIconSlider();
    initMobileSwiper();
    // $(window).on("resize", function() {
    //     initMobileSwiper();
    // });

    $('.js-mobile-menu-trigger').on('click', function(e) {
        e.preventDefault();

        $(this).toggleClass('is-open'); // adds/removes class to button
        $('.masthead__mobile-menu').toggleClass('is-visible');
    });


    $(".image-accordion__tab").on("click", function(e) {
        e.preventDefault();

        var index = $(this).data("tab");

        // Reset active states
        $(".image-accordion__tab").removeClass("is-active");
        $(".image-accordion__image").removeClass("is-active");

        // Activate current
        $(this).addClass("is-active");
        $('.image-accordion__image[data-image="' + index + '"]').addClass("is-active");
    });

    $(".image-accordion__tab a").on("click", function (e) {
        e.stopPropagation();
    });

    // Training Page Feed — tag filter pills. One bar per feed block; filtering
    // is scoped to that block only. Cards carry .tag-<id> classes; "All" is
    // data-filter="*". Hooked on .js- classes so the block's BEM roots can
    // change without breaking behaviour.
    $(document).on("click", ".js-feed-filter", function () {
        var $btn = $(this);
        var $scope = $btn.closest(".training-page-feed");
        $scope.find(".js-feed-filter").removeClass("active");
        $btn.addClass("active");
        var filter = $btn.data("filter");
        $scope.find(".js-feed-item").each(function () {
            $(this).toggle(filter === "*" || $(this).is(filter));
        });
    });

    // Course Modules List — disclosure-pattern accordion.
    // Each heading is a <button aria-expanded="..." aria-controls="..."> and
    // the body is collapsed via the native [hidden] attribute. Keyboard support
    // (Tab focus, Enter/Space activate) is inherent because the heading is a
    // real <button>; no additional keyboard handling needed for v1.
    $(".js-course-modules-toggle").on("click", function (e) {
        e.preventDefault();
        var $button = $(this);
        var bodyId = $button.attr("aria-controls");
        var $body = $("#" + bodyId);
        var nowExpanded = $button.attr("aria-expanded") !== "true";

        $button.attr("aria-expanded", nowExpanded ? "true" : "false");
        $button.closest(".course-modules-list__item").toggleClass("is-open", nowExpanded);

        if (nowExpanded) {
            $body.removeAttr("hidden");
        } else {
            $body.attr("hidden", "hidden");
        }
    });

    // Price & Dates panel (multi-module and single-module variants) — reveal
    // events beyond the initial visible cap. Rows past the cap carry the
    // `*__date--overflow` modifier and animate via CSS max-height/opacity
    // when .is-revealed is added.
    $(".js-price-and-dates-more").on("click", function (e) {
        e.preventDefault();
        var $button = $(this);
        var $panel = $button.closest(".price-and-dates-panel, .single-module-price-and-dates-panel");
        var nowExpanded = $button.attr("aria-expanded") !== "true";

        $button.attr("aria-expanded", nowExpanded ? "true" : "false");
        $button.text(nowExpanded ? "See fewer start dates" : "See more start dates");

        $panel.find(".price-and-dates-panel__date--overflow, .single-module-price-and-dates-panel__date--overflow")
              .toggleClass("is-revealed", nowExpanded);
    });

    // Filtered News Feed — tab switching. Pills and panels are pre-rendered
    // server-side; this only moves visibility. Generic .js- hooks (not BEM
    // roots) so the behaviour survives block forks; inert on pages without
    // the block.
    $(".js-filter-tabs").on("click", ".js-filter-tab", function (e) {
        e.preventDefault();
        var $pill = $(this);
        var $wrap = $pill.closest(".js-filter-tabs");
        var targetId = $pill.attr("aria-controls");

        $wrap.find(".js-filter-tab").removeClass("is-active").attr("aria-selected", "false");
        $pill.addClass("is-active").attr("aria-selected", "true");

        $wrap.find(".js-filter-tab-panel").each(function () {
            if (this.id === targetId) {
                $(this).removeAttr("hidden");
            } else {
                $(this).attr("hidden", "hidden");
            }
        });
    });

    // Film modal (n-up-video). The theme ships .modal CSS but no behaviour;
    // this opens a privacy-mode YouTube embed, and tears the iframe down on
    // close so playback stops. Closes on the X, the overlay, or Escape.
    (function () {
        var $modal = $('.js-film-modal');
        if (!$modal.length) {
            return;
        }
        var $frame = $modal.find('.js-film-frame');
        var lastTrigger = null;

        function openFilm(id, trigger) {
            if (!id) {
                return;
            }
            lastTrigger = trigger || null;
            $frame.html(
                '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
                '?autoplay=1&rel=0" title="Film" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>'
            );
            $modal.removeAttr('hidden');
            $('body').css('overflow', 'hidden');
            $modal.find('.modal__close').trigger('focus');
        }

        function closeFilm() {
            $modal.attr('hidden', 'hidden');
            $frame.empty();
            $('body').css('overflow', '');
            if (lastTrigger) {
                $(lastTrigger).trigger('focus');
                lastTrigger = null;
            }
        }

        $(document).on('click', '.js-film', function (e) {
            e.preventDefault();
            openFilm($(this).data('video'), this);
        });

        $modal.on('click', '.js-film-close', closeFilm);

        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && !$modal.attr('hidden')) {
                closeFilm();
            }
        });
    })();

    // Interactive Asset block. Each asset lives in an iframe and reports its
    // own height: { type: 'embed-height', height }. A frame is matched by
    // event.source, never by origin - a sandboxed asset's origin is "null" -
    // so two embeds on one page cannot move each other. Because this script
    // can attach after an asset has already reported, every frame is asked to
    // report again now and whenever it (re)loads. Inert without the block.
    (function () {
        var frames = document.querySelectorAll('.js-interactive-asset');
        if (!frames.length) {
            return;
        }

        window.addEventListener('message', function (e) {
            var data = e.data;
            if (!data || data.type !== 'embed-height' || typeof data.height !== 'number' || !isFinite(data.height)) {
                return;
            }
            for (var i = 0; i < frames.length; i++) {
                if (frames[i].contentWindow === e.source) {
                    frames[i].style.height = Math.min(Math.max(Math.ceil(data.height), 0), 20000) + 'px';
                    return;
                }
            }
        });

        function requestHeight(frame) {
            if (frame.contentWindow) {
                frame.contentWindow.postMessage({ type: 'embed-height-request' }, '*');
            }
        }

        for (var i = 0; i < frames.length; i++) {
            (function (frame) {
                frame.addEventListener('load', function () {
                    requestHeight(frame);
                });
                requestHeight(frame);
            })(frames[i]);
        }
    })();

    AOS.init({
        once: true, // optional, run animation only once
        duration: 600, // optional, animation duration
        easing: 'ease-out', // optional, easing function
    });


});